
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import App from './App';
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoginLogo from "./components/pages/LoginLogo/3409297.jpg";
// import Loginlogo from "./Loginlogo.png";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Person4Icon from '@mui/icons-material/Person4';
import { FaUser, FaLock, FaEye, FaEyeSlash, FaSpinner } from "react-icons/fa";

const LoginForm = () => {
  const history = useHistory();
  const { isAuthenticated, login } = useAuth();
  const [companyCode, setCompanyCode] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [branchId, setBranchId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginFailed, setLoginFailed] = useState(false);
  const [companyCodeValidated, setCompanyCodeValidated] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [branchstate, setbranchstate] = useState('');
  const location = useLocation();
  const [isAnimating, setIsAnimating] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCompanyValidation = async () => {
    try {
      if (!companyCode.trim()) {
        toast.error('Branch code is required.', {
          position: toast.POSITION.TOP_CENTER,
        });
      }

      if (companyCode.trim()) {

        const CompanyData = {
          BranchCode: companyCode,
        };

        const response = await postLogin('BranchLoginApi', CompanyData);

        if (response.responseCode === '1111') {
          setCompanyCodeValidated(true);
          setCompanyId(response.response_data.companyId)
          setBranchId(response.response_data.id)
          setCompanyName(response.response_data.name);
          setbranchstate(response.response_data.branchstate)
          setLoginFailed(false); // Reset loginFailed state
        } else {
          //throw new Error(response.Message);
          toast.error('Invalid Branch code', {
            position: toast.POSITION.TOP_CENTER,
          });
        }

      }

    } catch (error) {
      toast.error("Branch login failed", {
        //position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  useEffect(() => {
    setIsAnimating(true);
  }, []);

  const handleLogin = async () => {
    try {

      if (!companyCodeValidated) {
        throw new Error('Branch code validation is required.');
      }

      const jwtToken = await performLogin();
      const responseData = jwtDecode(jwtToken);
      const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
      const permissions = Object.keys(responseData).filter(
        (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
      );

      let isSuper = false;
      if (responseData.isSuperAdmin.toLowerCase() === "true") {
        isSuper = true;
      }

      
      let ispurchaseRequestNeeded = false;      

      if (isSuper == false) {
        const parsedCompanyId = parseInt(responseData.companyId, 10);

        if (parsedCompanyId === companyId) {
          login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName, branchstate, ispurchaseRequestNeeded, responseData.username);
          const redirectParam = new URLSearchParams(location.search).get("redirect");
          const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
          history.replace(redirectPath);
        }
        else {
          toast.error('Invalid User !', {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
      else {
        login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName, branchstate, ispurchaseRequestNeeded, responseData.username);
        const redirectParam = new URLSearchParams(location.search).get("redirect");
        const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
        history.replace(redirectPath);
      }

    } catch (error) {
      toast.error('Login failed', {
        // position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const performLogin = async () => {
    const loginData = {
      UserName: username,
      Password: password,
      CompanyId: companyId,
      BranchId: branchId
    };

    const response = await postLogin('LoginApi', loginData);

    if (response.responseCode === '1111') {
      const jwtToken = response.response_data.token;

      return jwtToken;
    } else {
      throw new Error(response.Message);
    }
  };

  const closeModal = () => {
    setLoginFailed(false);
  };

  if (isAuthenticated) {
    return <App />;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#183955ff",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
        transition: "background 0.3s ease-in-out",
      }}
    >
      <ToastContainer position="top-center" autoClose={3000} />
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "30px",
          borderRadius: "16px",
          background: "#27445D",
          boxShadow: "0 8px 30px rgba(0,0,0,0.4)",
          textAlign: "center",
          transform: "scale(1)",
          animation: "fadeIn 1s ease",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "20px", // Space between image and text
          }}
        >
          {/* <img
            src={Loginlogo}
            alt="Login Logo"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
              marginTop: "-10px",
            }}
          /> */}
          <h5
            style={{
              fontWeight: "600",
              fontFamily: "Lucida Handwriting",
              color: "#fff",
              textTransform: "uppercase",
            }}
          >
            Gender Looms
          </h5>
        </div>

        {!companyCodeValidated ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleCompanyValidation();
            }}
          >
            <div style={{ position: "relative", marginBottom: "1.5rem" }}>
              <span
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#aaa",
                }}
              >
                🏢
              </span>
              <input
                type="text"
                placeholder="Enter Branch Code"
                value={companyCode}
                onChange={(e) => setCompanyCode(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px 10px 12px 35px",
                  borderRadius: "6px",
                  border: "1px solid #4c6793",
                  background: "#27445D",
                  color: "#fff",
                  outline: "none",
                  transition: "border 0.3s ease",
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "10px",
                borderRadius: "8px",
                border: "1px solid #fff",
                background: loading ? "#fff" : "transparent",
                color: loading ? "#000" : "#fff",
                fontWeight: "bold",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {loading ? <FaSpinner style={{ animation: "spin 1s linear infinite" }} /> : null}
              {loading ? "Validating..." : "Validate Branch Code"}
            </button>
          </form>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}
          >
            <p
              style={{
                fontSize: "16px",
                fontWeight: "500",
                marginBottom: "20px",
                color: "#d3d3d3",
                fontFamily: "cursive",
              }}
            >
              Welcome to {companyName}
            </p>

            {/* Username */}
            <div style={{ position: "relative", marginBottom: "15px" }}>
              <FaUser
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  color: "#ccc",
                }}
              />
              <input
                type="text"
                placeholder="User Name"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 10px 10px 40px",
                  borderRadius: "8px",
                  border: "1px solid #4c6793",
                  background: "#27445D",
                  color: "#fff",
                  outline: "none",
                  transition: "border 0.3s ease",
                }}
              />
            </div>

            {/* Password */}
            <div style={{ position: "relative", marginBottom: "15px" }}>
              <FaLock
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  color: "#ccc",
                }}
              />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 10px 10px 40px",
                  borderRadius: "8px",
                  border: "1px solid #4c6793",
                  background: "#27445D",
                  color: "#fff",
                  outline: "none",
                  transition: "border 0.3s ease",
                }}
              />
              <div
                onClick={() => setShowPassword((prev) => !prev)}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  color: "#ccc",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "15px",
                borderRadius: "8px",
                border: "1px solid #fff",
                background: loading ? "#fff" : "transparent",
                color: loading ? "#000" : "#fff",
                fontWeight: "bold",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {loading ? <FaSpinner style={{ animation: "spin 1s linear infinite" }} /> : null}
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        )}
      </div>

      {/* Spinner animation keyframes */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
};

export default LoginForm;

